// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  z-index: 101;
  flex-wrap: wrap;
  overflow-x: hidden;
  background: rgba(37, 37, 37, 0.23);
}
@media (max-width: 767px) {
  .modal {
    align-items: start;
  }
}
.modal__wrap {
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  width: 100%;
  max-width: 450px;
  background: #131313;
  border: 1px solid var(--accent-color);
  border-radius: 15px;
  padding: 30px;
  margin: 30px 0;
  align-self: center;
  transform: scale(0.9);
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .modal__wrap {
    padding: 30px 20px;
    margin: 0;
    min-height: 100%;
    border-radius: 0;
    border: none;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 767px) and (min-height: 750px) {
  .modal__wrap {
    align-items: center;
  }
}
.modal__close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff0000;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.modal__close svg path {
  stroke: #fff;
}
.modal__close:hover {
  background: #ff5646;
}
.modal__title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #fff;
  text-transform: uppercase;
  padding-bottom: 30px;
}
@media (max-width: 767px) {
  .modal__title {
    font-size: 18px;
  }
}
.modal__description {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 162.5%;
  color: #fff;
}
@media (max-width: 767px) {
  .modal__description {
    font-size: 14px;
  }
}
.modal__description a {
  color: #3E474C;
  text-decoration: underline;
}
.modal__info {
  font-size: 16px;
  line-height: 162.5%;
  color: #3E474C;
}
@media (max-width: 767px) {
  .modal__info {
    font-size: 14px;
  }
}
.modal__buttons {
  position: relative;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .modal__buttons {
    flex-wrap: wrap;
  }
}
.modal__confirm {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 20px;
}
.modal__btn {
  min-width: auto;
  margin-right: 10px;
  padding-right: 24px;
  padding-left: 24px;
}
@media (max-width: 767px) {
  .modal__btn {
    margin-right: 5px;
  }
}
.modal.active {
  visibility: visible;
  opacity: 1;
}
.modal.active .modal__wrap {
  transform: scale(1);
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Modal/Modal.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AACA;EAEE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAGA,kCAAA;AAHF;AAIE;EApBF;IAqBI,kBAAA;EADF;AACF;AAEE;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;EACA,mBC1BM;ED2BN,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAAJ;AACI;EAbF;IAcI,kBAAA;IACA,SAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;EAEJ;AACF;AAFM;EArBJ;IAsBM,mBAAA;EAKN;AACF;AAFE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAIJ;AAFM;EACE,YAAA;AAIR;AADI;EACE,mBAAA;AAGN;AACE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AACJ;AAAI;EARF;IASI,eAAA;EAGJ;AACF;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAGJ;AAFI;EANF;IAOI,eAAA;EAKJ;AACF;AAJI;EACE,cAAA;EACA,0BAAA;AAMN;AAHE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAKJ;AAJI;EAJF;IAKI,eAAA;EAOJ;AACF;AALE;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AAOJ;AANI;EALF;IAMI,eAAA;EASJ;AACF;AAPE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AASJ;AAPE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AASJ;AARI;EALF;IAMI,iBAAA;EAWJ;AACF;AATE;EACE,mBAAA;EACA,UAAA;AAWJ;AAVI;EACE,mBAAA;AAYN","sourcesContent":["@import '../../../styles/_variables';\r\n.modal{\r\n  $self: &;\r\n  position: fixed;\r\n  top:0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  margin:auto;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  z-index: 101;\r\n  flex-wrap: wrap;\r\n  overflow-x: hidden;\r\n\r\n\r\n  background: rgba(37, 37, 37, 0.23);\r\n  @media (max-width:767px){\r\n    align-items: start;\r\n  }\r\n  &__wrap{\r\n    position: relative;\r\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\r\n    width: 100%;\r\n    max-width: 450px;\r\n    background: $primary;\r\n    border: 1px solid $accent;\r\n    border-radius: 15px;\r\n    padding: 30px;\r\n    margin: 30px 0;\r\n    align-self: center;\r\n    transform: scale(0.9);\r\n    transition: all 0.3s ease;\r\n    @media (max-width:767px){\r\n      padding: 30px 20px;\r\n      margin: 0;\r\n      min-height: 100%;\r\n      border-radius: 0;\r\n      border: none;\r\n      display: flex;\r\n      justify-content: center;\r\n      @media (min-height:750px){\r\n        align-items: center;\r\n      }\r\n    }\r\n  }\r\n  &__close{\r\n    position:absolute;\r\n    right:15px;\r\n    top:15px;\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background:#ff0000;\r\n    border-radius: 4px;\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    svg{\r\n      path{\r\n        stroke: #fff;\r\n      }\r\n    }\r\n    &:hover{\r\n      background: #ff5646;\r\n    }\r\n  }\r\n\r\n  &__title{\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n    color:#fff;\r\n    text-transform: uppercase;\r\n    padding-bottom: 30px;\r\n    @media (max-width:767px){\r\n      font-size: 18px;\r\n    }\r\n  }\r\n  &__description{\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 162.5%;\r\n    color: #fff;\r\n    @media (max-width:767px){\r\n      font-size: 14px;\r\n    }\r\n    a{\r\n      color: #3E474C;\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n  &__info{\r\n    font-size: 16px;\r\n    line-height: 162.5%;\r\n    color: #3E474C;\r\n    @media (max-width:767px){\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  &__buttons{\r\n    position: relative;\r\n    padding-top: 30px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    @media (max-width:767px){\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__confirm{\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    gap:20px;\r\n  }\r\n  &__btn{\r\n    min-width: auto;\r\n    margin-right: 10px;\r\n    padding-right: 24px;\r\n    padding-left: 24px;\r\n    @media (max-width:767px){\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n  &.active{\r\n    visibility: visible;\r\n    opacity: 1;\r\n    #{$self}__wrap{\r\n      transform: scale(1.0);\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
